import { z } from "zod";

import { departmentType, citizenshipType } from "../../../constant/enum";
import { IBranch } from "../../../general/type/branch.types";
import { IUserResponse } from "../../user/type/user";

// Base payslip fields that are common to both request and response
const BasePayslipSchema = z.object({
  department: z.enum(departmentType as [string, ...string[]]),
  userId: z.string(),
  basicSalary: z.number().default(0),
  fixedAllowance: z.number().optional(),
  staffIncentive: z.number().optional(),
  otherIncentive: z.number().optional(),
  isUnder60: z.boolean().default(true),
  citizenship: z
    .enum(citizenshipType as [string, ...string[]])
    .default("malaysian"),
});

// Schema for creating/updating payslips
export const PayslipRequestSchema = BasePayslipSchema.extend({
  payslipDate: z.date(),
});

// Schema for payslip responses from API
export const PayslipResponseSchema = BasePayslipSchema.extend({
  id: z.string(),
  branch: z.custom<IBranch>().optional(),
  user: z.custom<IUserResponse>(),
  contribution: z.object({
    epf: z.object({
      employee: z.number().positive(),
      employer: z.number().positive(),
      total: z.number().positive(),
    }),
    socso: z.object({
      employee: z.number().positive(),
      employer: z.number().positive(),
      total: z.number().positive(),
    }),
    eis: z.object({
      employee: z.number().positive(),
      employer: z.number().positive(),
      total: z.number().positive(),
    }),
  }),
  payslipUrl: z.string().url(),
  payslipDate: z.date(),
  archive: z.date().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type IPayslipRequest = z.infer<typeof PayslipRequestSchema>;
export type IPayslipResponse = z.infer<typeof PayslipResponseSchema>;

export interface IApiResponseGetPayslips {
  results: IPayslipResponse[];
  page: string;
  limit: number;
  totalPages: number;
  totalResults: number;
}
